import React from 'react'
import Lottie from "lottie-react";
import TMLLoader from '../../src/assets/TMLLoader.json'

export default function Loader() {
  return (
    <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Lottie style={{ height: 200, width: 350 }} animationData={TMLLoader} loop={true} />
    </div>
  )
}
